export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-image-gallery/_content-section-image-gallery.twig";